import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { authGuard } from './service/guards/auth.guard';
import { HomeComponent } from './pages/portal/home/home.component';
import { RegistrationComponent } from './pages/portal/vendor/registration/registration.component';
import { ListComponent } from './pages/portal/vendor/list/list.component';
import { ViewPurchaseOrderComponent } from './pages/portal/purchase-order/view-purchase-order/view-purchase-order.component';
import { ShipmentComponent } from './pages/portal/order/shipment/shipment.component';
import { ScheduleComponent } from './pages/portal/order/schedule/schedule.component';
import { VendorNotFoundComponent } from './pages/portal/vendor-not-found/vendor-not-found.component';
import { VendorDetailComponent } from './pages/portal/vendor/vendor-detail/vendor-detail.component';
import { CreateShipmentAsnComponent } from './pages/portal/shimpent-asn/create-shipment-asn/create-shipment-asn.component';
import { ProcessShimpentAsnComponent } from './pages/portal/shimpent-asn/process-shimpent-asn/process-shimpent-asn.component';
import { VendorDetailByIdComponent } from './pages/portal/vendor/vendor-detail-by-id/vendor-detail-by-id.component';
import { TokenComponent } from './pages/portal/order/token/token.component';
import { GateInComponent } from './pages/portal/gate-management/gate-in/gate-in.component';
import { GateOutComponent } from './pages/portal/gate-management/gate-out/gate-out.component';
import { VisitorPassComponent } from './pages/portal/gate-management/visitor-pass/visitor-pass.component';
import { GrComponent } from './pages/portal/gr-ir/gr/gr.component';
import { IrComponent } from './pages/portal/gr-ir/ir/ir.component';
import { AddVendorUserComponent } from './pages/portal/vendor/add-vendor-user/add-vendor-user.component';
import { ApproveVendorListComponent } from './pages/portal/vendor/approve-vendor-list/approve-vendor-list.component';
import { PendingVendorListComponent } from './pages/portal/vendor/pending-vendor-list/pending-vendor-list.component';
import { PendingVendorApprovalComponent } from './pages/portal/vendor/pending-vendor-approval/pending-vendor-approval.component';
import { ProfileComponent } from './pages/portal/profile/profile.component';
import { ChangeRequestComponent } from './pages/portal/vendor/change-request/change-request.component';
import { ViewReconciliationComponent } from './pages/portal/vendor/view-reconciliation/view-reconciliation.component';
import { ViewPaymentComponent } from './pages/portal/payment/view-payment/view-payment.component';
import { PendingReviewComponent } from './pages/portal/vendor/pending-review/pending-review.component';
import { VisitorGateOutPassComponent } from './pages/portal/gate-management/visitor-gate-out-pass/visitor-gate-out-pass.component';
import { ChangeDetailComponent } from './pages/portal/vendor/change-detail/change-detail.component';
import { PendingChangeRequestComponent } from './pages/portal/vendor/pending-change-request/pending-change-request.component';
import { ViewVendorDetailsComponent } from './pages/portal/vendor/view-vendor-details/view-vendor-details.component';
import { GrLineItemComponent } from './pages/portal/gr-ir/gr-line-item/gr-line-item.component';
import { VendorBlackListComponent } from './pages/portal/vendor/vendor-black-list/vendor-black-list.component';
import { AddUserRoleComponent } from './pages/portal/vendor/add-user-role/add-user-role.component';
import { AddUserCreationComponent } from './pages/portal/vendor/add-user-creation/add-user-creation.component';
import { VendorBlackLegalListComponent } from './pages/portal/vendor/vendor-black-legal-list/vendor-black-legal-list.component';
import { RejectVendorListComponent } from './pages/portal/vendor/reject-vendor-list/reject-vendor-list.component';
import { VendorQueryListComponent } from './pages/portal/vendor/vendor-query-list/vendor-query-list.component';
import { ChangeDetailHistoryComponent } from './pages/portal/vendor/change-detail-history/change-detail-history.component';
import { UploadInvoiceComponent } from './pages/upload-invoice/upload-invoice.component';

const routes: Routes = [
  {
    path: '', component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: HomeComponent},
      { path: 'portal/vendor/change-request/:id', component: ChangeRequestComponent},
      { path:'portal/vendor/registration', component:RegistrationComponent},
      { path: 'portal/vendor/add-vendor-user',component: AddVendorUserComponent},
      { path: 'view-purchase-order', component: ViewPurchaseOrderComponent},
      { path: 'portal/order/shipment', component: ShipmentComponent},
      { path: 'portal/vendor/list', component: ListComponent},
      { path: 'portal/order/schedule', component: ScheduleComponent },
      { path: 'portal/vendor-not-found', component: VendorNotFoundComponent },
      { path: 'vendor-detail/:id', component: VendorDetailComponent },
      { path: 'create-shipment-asn', component:CreateShipmentAsnComponent},
      { path: 'process-shipment-asn', component: ProcessShimpentAsnComponent },
      { path: 'portal/vendor/vendor-detail-by-id' , component:VendorDetailByIdComponent},
      { path: 'token', component: TokenComponent },
      { path: 'gate-in', component: GateInComponent },
      { path: 'gate-out', component: GateOutComponent },
      { path: 'visitor-pass', component: VisitorPassComponent },
      { path: 'visitor-gate-out-pass', component: VisitorGateOutPassComponent },
      { path: 'gr', component: GrComponent  },
      { path: 'gr-line-item', component: GrLineItemComponent  },
      { path: 'ir', component: IrComponent },
      { path: 'approve-vendor-list', component: ApproveVendorListComponent },
      { path: 'pending-vendor-list', component: PendingVendorListComponent },
      { path: 'pending-vendor-approval', component: PendingVendorApprovalComponent },
      { path: 'profile', component: ProfileComponent},
      { path: 'portal/payment/view-payment', component: ViewPaymentComponent},
      { path: 'pending-review', component: PendingReviewComponent},
      { path: 'change-detail', component: ChangeDetailComponent},
      { path: 'pending-change-request', component: PendingChangeRequestComponent},
      { path: 'view-vendor-details/:id', component: ViewVendorDetailsComponent},
      { path: 'vendor-black-list', component: VendorBlackListComponent},
      { path: 'add-user-role',component: AddUserRoleComponent},
      { path: 'add-user-creation',component: AddUserCreationComponent},
      { path: 'view-reconciliation',component: ViewReconciliationComponent},
      { path: 'vendor-black-and-legal-list',component: VendorBlackLegalListComponent},
      { path: 'reject-vendor-list',component: RejectVendorListComponent},
      { path: 'vendor-query-list',component: VendorQueryListComponent},
      { path: 'upload-invoice',component: UploadInvoiceComponent},
      { path: 'change-detail-history',component: ChangeDetailHistoryComponent},
    ]
  },
  { path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule) },
  { path: 'notfound', component: NotfoundComponent },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
